import { useEffect, useState } from 'react';
import type { WCardTemplateView, WWeddingView } from '@zola/svc-web-api-ts-client';
import fetchTemplate from '../api/fetchTemplate';
import type { CardSuiteInfoSummary, CustomTemplateSummary } from '../types';
import {
  mapWeddingDetailsToSubstitutions,
  mapCardInfoSummaryToCardSuite,
  mapCardSuiteSummaryToPreviewTemplates,
  mapCardSuiteToVariations,
} from '../mappers';

export default function useTemplatesFromCardSuite(
  cardSuiteInfo?: CardSuiteInfoSummary,
  weddingDetails?: WWeddingView,
  maxLimit?: number,
  initialColor?: string
): CustomTemplateSummary[] | undefined {
  const [templates, setTemplates] = useState<CustomTemplateSummary[] | undefined>();

  useEffect(() => {
    if (cardSuiteInfo && cardSuiteInfo.sampleCard) {
      let variations = mapCardSuiteToVariations(
        mapCardInfoSummaryToCardSuite(cardSuiteInfo),
        initialColor
      );
      if (maxLimit) {
        variations = variations?.slice(0, maxLimit);
      }
      const substitutions = mapWeddingDetailsToSubstitutions(weddingDetails);

      fetchTemplate(variations, substitutions)
        .then((res: Record<string, WCardTemplateView> | null): void => {
          const cardSuiteSummary = mapCardInfoSummaryToCardSuite(cardSuiteInfo);
          const customTemplates = mapCardSuiteSummaryToPreviewTemplates(cardSuiteSummary, res);

          setTemplates(customTemplates);
        })
        // eslint-disable-next-line no-console
        .catch(e => console.log(e));
    }
  }, [cardSuiteInfo, maxLimit, weddingDetails]);

  return templates;
}
